// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* material.css - Complete file with preserved table design + enhanced payment modal & filters */

/* ────────────────────────────────────────────────────────────── */
/*                        ROOT VARIABLES                          */
/* ────────────────────────────────────────────────────────────── */
:root {
  --primary: #14b8a6;
  --primary-dark: #0d8a7b;
  --primary-light: #ecfdf9;
  --success: #16a34a;
  --danger: #dc2626;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --radius: 12px;
  --shadow: 0 4px 16px rgba(0,0,0,0.08);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.material-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.page-title {
  font-size: 2.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--gray-800), var(--primary-dark));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.page-subtitle {
  color: var(--gray-600);
  margin-top: 0.4rem;
}

.header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

/* ────────────────────────────────────────────────────────────── */
/*                    IMPROVED FILTERS & BUTTONS                  */
/* ────────────────────────────────────────────────────────────── */

.filter-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  padding: 0 12px;
  height: 42px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  transition: all 0.2s;
}

.filter-box:hover,
.filter-box:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(20,184,166,0.1);
}

.filter-box select {
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  color: var(--gray-700);
  cursor: pointer;
  min-width: 140px;
}

/* Record Payment & Export Buttons */
.record-payment-btn,
.export-excel-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 7px;
  border-radius: 8px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.record-payment-btn {
  background: var(--primary);
  color: white;
}

.record-payment-btn:hover {
  background: var(--primary-dark);
  transform: translateY(-2px);
}

.export-excel-btn {
  background: #f59e0b;
  color: white;
}

.export-excel-btn:hover {
  background: #d97706;
  transform: translateY(-2px);
}

.fab-btn {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(20,184,166,0.3);
  transition: all 0.3s;
  text-decoration: none;
}

.fab-btn:hover {
  transform: translateY(-4px);
}

/* ────────────────────────────────────────────────────────────── */
/*                  MODERN FINANCIAL CARDS                        */
/* ────────────────────────────────────────────────────────────── */

.financial-overview-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
  margin: 1.5rem 0 2.5rem;
}

.finance-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.finance-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.finance-label {
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 0.6rem;
}

.finance-value {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.finance-card.total   { border-left: 5px solid #3b82f6; }
.finance-card.paid    { border-left: 5px solid #10b981; }
.finance-card.balance { border-left: 5px solid #ef4444; }

/* ────────────────────────────────────────────────────────────── */
/*               PRESERVED ORIGINAL TABLE DESIGN                  */
/* ────────────────────────────────────────────────────────────── */

.table-responsive {
  overflow-x: auto;
  background: white;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.materials-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.materials-table th,
.materials-table td {
  padding: 1rem 1.1rem;
  text-align: left;
  border-bottom: 1px solid var(--gray-200);
}

.materials-table th {
  background: var(--primary-light);
  color: var(--gray-700);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
}

.materials-table tbody tr:hover {
  background: rgba(20,184,166,0.05);
}

.amount {
  font-weight: 600;
  color: var(--success);
}

.image-cell {
  text-align: center;
}

.thumbnail {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

.no-image {
  color: var(--gray-500);
  font-size: 0.85rem;
}

.action-btn {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--gray-300);
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.action-btn.view {
  background: var(--primary-light);
  color: var(--primary-dark);
  border-color: var(--primary);
}

/* Mobile stacked layout - PRESERVED */
@media (max-width: 992px) {
  .materials-table thead { display: none; }
  .materials-table tr {
    display: block;
    margin-bottom: 1.5rem;
    background: white;
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1rem;
  }
  .materials-table td {
    display: flex;
    justify-content: space-between;
    border: none;
    padding: 0.8rem 1rem;
    border-bottom: 1px solid var(--gray-100);
  }
  .materials-table td:last-child {
    border-bottom: none;
    justify-content: center;
  }
  .materials-table td:before {
    content: attr(data-label);
    font-weight: 600;
    color: var(--gray-700);
    flex: 0 0 40%;
    padding-right: 1rem;
  }
}

/* ────────────────────────────────────────────────────────────── */
/*                        MODALS - BASE                           */
/* ────────────────────────────────────────────────────────────── */

.modal-backdrop.deluxe,
.image-viewer {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-card.deluxe {
  background: white;
  border-radius: 20px;
  max-width: 600px;
  width: 92%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0,0,0,0.3);
}

.modal-card.deluxe.large {
  max-width: 900px;
}

.modal-header.deluxe {
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: white;
  padding: 1.6rem 2rem;
  position: relative;
}

.close-btn.deluxe {
  position: absolute;
  top: 1rem;
  right: 1.5rem;
  background: rgba(255,255,255,0.3);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}

.modal-body {
  padding: 1.8rem;
  max-height: 65vh;
  overflow-y: auto;
}

/* ────────────────────────────────────────────────────────────── */
/*         ENHANCED PAYMENT MANAGEMENT MODAL ONLY                 */
/* ────────────────────────────────────────────────────────────── */

.payment-management-modal .modal-card.deluxe {
  max-width: 960px;
}

.payment-management-modal .modal-header.deluxe {
  background: linear-gradient(135deg, #0f766e, #0d8a7b);
}

.payment-management-modal h2 {
  font-size: 1.6rem;
  font-weight: 700;
}

.payment-management-modal .modal-body {
  padding: 2rem;
  background: #f8fafc;
}

.payments-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  margin: 1.5rem 0;
}

.payments-table thead th {
  background: #e0f2f1;
  color: #0d8a7b;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 1rem;
  border: none;
}

.payments-table tbody tr {
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border-radius: 10px;
  transition: all 0.2s;
}

.payments-table tbody tr:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.1);
}

.payments-table td {
  padding: 1.1rem;
  border: none;
}

.payments-table td:nth-child(2) {
  font-weight: 700;
  color: var(--success);
  font-size: 1.1rem;
}

.payment-form {
  background: white;
  border-radius: 12px;
  padding: 1.6rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-top: 1.5rem;
}

.payment-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.4rem;
}

.payment-form .full-width {
  grid-column: 1 / -1;
}

.payment-form label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--gray-700);
}

.payment-form input,
.payment-form textarea {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  transition: all 0.2s;
}

.payment-form input:focus,
.payment-form textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(20,184,166,0.15);
  outline: none;
}

/* Modal Actions */
.modal-actions.deluxe.multiple {
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-top: 1px solid var(--gray-200);
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.modal-actions button {
  padding: 0.8rem 1.6rem;
  border-radius: 8px;
  font-weight: 600;
  min-width: 140px;
  transition: all 0.2s;
}

.btn-secondary { background: #6b7280; color: white; }
.btn-success   { background: var(--success); color: white; }
.btn-primary   { background: var(--primary); color: white; }
.btn-danger    { background: var(--danger); color: white; }

.btn-ghost {
  background: transparent;
  border: 2px solid var(--gray-300);
  color: var(--gray-700);
}

/* ────────────────────────────────────────────────────────────── */
/*                        OTHER ELEMENTS                          */
/* ────────────────────────────────────────────────────────────── */

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
  margin-bottom: 1.5rem;
}

.detail-grid div {
  background: #f8fafc;
  padding: 1rem;
  border-radius: 8px;
}

.remark-box {
  background: #ecfdf5;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #10b981;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.items-table th,
.items-table td {
  padding: 0.9rem;
  text-align: left;
  border-bottom: 1px solid var(--gray-200);
}

.total-row td {
  padding-top: 1rem;
  font-size: 1.1rem;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid var(--gray-200);
}

.price-row input {
  width: 120px;
  padding: 0.7rem;
  border: 2px solid var(--gray-300);
  border-radius: 10px;
  text-align: right;
}

.empty-state {
  text-align: center;
  padding: 5rem 2rem;
  color: var(--gray-600);
}

.empty-icon {
  color: var(--gray-400);
  margin-bottom: 1.5rem;
}

.loader, .error-msg {
  text-align: center;
  padding: 5rem;
  font-size: 1.3rem;
}

.image-viewer img {
  max-width: 94vw;
  max-height: 90vh;
  border-radius: 12px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.4);
}

.close-image {
  position: absolute;
  top: 20px;
  right: 30px;
  background: rgba(0,0,0,0.6);
  color: white;
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.8rem;
}

/* Responsive */
@media (max-width: 768px) {
  .payment-form .form-grid {
    grid-template-columns: 1fr;
  }
}


























/* ============= PREMIUM ADD MATERIAL FORM ============= */


.page-container {
  background: #f2f4f7;
  min-height: 100vh;
  padding: 30px;
}

.page-card {
  max-width: 1200px;
  margin: auto;
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.page-header h2 {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
}

.page-header p {
  margin: 4px 0 25px;
  color: #777;
  font-size: 14px;
}

.section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  margin-bottom: 15px;
  color: #222;
  border-left: 4px solid #0d6efd;
  padding-left: 10px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.field {
  display: flex;
  flex-direction: column;
}

.field.full {
  margin-top: 15px;
}

.field label {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
}

input,
select,
textarea {
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid #d0d5dd;
  font-size: 14px;
}

.material-box {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.material-head,
.material-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 0.5fr;
  gap: 12px;
  padding: 10px;
  align-items: center;
}

.material-head {
  background: #f9fafb;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #e5e7eb;
}

.material-row {
  border-bottom: 1px solid #f1f1f1;
}

.material-row:last-child {
  border-bottom: none;
}

.total {
  font-weight: 600;
  color: #111;
}

.delete-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #dc3545;
}

.add-row-btn {
  margin-top: 15px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef2ff;
  border: 1px dashed #6366f1;
  color: #3730a3;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.footer button {
  background: #0d6efd;
  color: #fff;
  padding: 10px 30px;
  border-radius: 8px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}

.alert-error {
  background: #fee2e2;
  color: #991b1b;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 15px;
}


/* ═══════════════════════════════════════════════════════════════
   material.css  —  Professional redesign
   ═══════════════════════════════════════════════════════════════ */

/* ── tokens ─────────────────────────────────────────────────── */
:root {
  --mat-teal:          #0F6E56;
  --mat-teal-hover:    #085041;
  --mat-teal-light:    #E1F5EE;
  --mat-teal-mid:      #5DCAA5;

  --mat-red:           #993C1D;
  --mat-red-light:     #FAECE7;
  --mat-red-mid:       #F0997B;

  --mat-green:         #3B6D11;
  --mat-green-light:   #EAF3DE;

  --mat-amber-light:   #FAEEDA;
  --mat-amber:         #BA7517;

  --mat-gray-100:      #F5F4F1;
  --mat-gray-200:      #E8E7E3;
  --mat-gray-400:      #A8A7A0;
  --mat-gray-600:      #5F5E5A;
  --mat-gray-900:      #1A1A18;

  --mat-border:        rgba(0,0,0,0.08);
  --mat-border-md:     rgba(0,0,0,0.13);

  --mat-radius-sm:     6px;
  --mat-radius-md:     8px;
  --mat-radius-lg:     12px;

  --mat-shadow-sm:     0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.05);
  --mat-shadow-md:     0 4px 16px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06);
  --mat-shadow-lg:     0 12px 40px rgba(0,0,0,0.14), 0 4px 12px rgba(0,0,0,0.08);

  --mat-font:          'DM Sans', system-ui, -apple-system, sans-serif;
  --mat-font-mono:     'DM Mono', ui-monospace, monospace;
}

/* ── page shell ─────────────────────────────────────────────── */
.mat-page {
  font-family: var(--mat-font);
  color: var(--mat-gray-900);
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem 1.5rem 3rem;
}

/* ── page header ─────────────────────────────────────────────── */
.mat-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
  flex-wrap: wrap;
}
.mat-header__title {
  font-size: 1.375rem;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: var(--mat-gray-900);
  margin: 0;
}
.mat-header__sub {
  font-size: 0.8125rem;
  color: var(--mat-gray-400);
  margin: 3px 0 0;
}
.mat-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* ── buttons ─────────────────────────────────────────────────── */
.mat-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  height: 36px;
  border-radius: var(--mat-radius-md);
  font-size: 0.8125rem;
  font-weight: 500;
  font-family: var(--mat-font);
  cursor: pointer;
  border: 1px solid var(--mat-border-md);
  background: #fff;
  color: var(--mat-gray-900);
  transition: background 0.13s, border-color 0.13s, box-shadow 0.13s;
  white-space: nowrap;
  text-decoration: none;
}
.mat-btn:hover  { background: var(--mat-gray-100); }
.mat-btn:active { transform: scale(0.98); }

.mat-btn--primary {
  background: var(--mat-teal);
  border-color: var(--mat-teal);
  color: #fff;
}
.mat-btn--primary:hover { background: var(--mat-teal-hover); border-color: var(--mat-teal-hover); }

.mat-btn--ghost {
  background: transparent;
  border-color: var(--mat-border);
  color: var(--mat-gray-600);
}
.mat-btn--ghost:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); }

.mat-btn--danger {
  background: var(--mat-red-light);
  border-color: var(--mat-red-mid);
  color: var(--mat-red);
}
.mat-btn--danger:hover { background: #F5C4B3; }

.mat-btn--fab {
  width: 36px;
  height: 36px;
  padding: 0;
  justify-content: center;
  background: var(--mat-teal);
  border-color: var(--mat-teal);
  color: #fff;
  border-radius: var(--mat-radius-md);
}
.mat-btn--fab:hover { background: var(--mat-teal-hover); }

/* ── filter ──────────────────────────────────────────────────── */
.mat-filter {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--mat-border-md);
  border-radius: var(--mat-radius-md);
  background: #fff;
  color: var(--mat-gray-600);
  font-size: 0.8125rem;
  position: relative;
}
.mat-filter select {
  border: none;
  background: transparent;
  font-size: 0.8125rem;
  color: var(--mat-gray-900);
  outline: none;
  cursor: pointer;
  padding-right: 16px;
  appearance: none;
  font-family: var(--mat-font);
}
.mat-filter__chevron {
  position: absolute;
  right: 8px;
  pointer-events: none;
  color: var(--mat-gray-400);
}

/* ── stat cards ──────────────────────────────────────────────── */
.mat-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 1.75rem;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 1rem 1.25rem;
  border-radius: var(--mat-radius-lg);
  border: 1px solid var(--mat-border);
  background: #fff;
  box-shadow: var(--mat-shadow-sm);
}
.stat-card__icon {
  width: 38px;
  height: 38px;
  border-radius: var(--mat-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-card--neutral .stat-card__icon { background: var(--mat-gray-100); color: var(--mat-gray-600); }
.stat-card--success .stat-card__icon { background: var(--mat-green-light); color: var(--mat-green); }
.stat-card--danger  .stat-card__icon { background: var(--mat-red-light);   color: var(--mat-red);   }

.stat-card__label {
  font-size: 0.75rem;
  color: var(--mat-gray-400);
  margin: 0 0 3px;
}
.stat-card__value {
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0;
  color: var(--mat-gray-900);
}
.stat-card--success .stat-card__value { color: var(--mat-green); }
.stat-card--danger  .stat-card__value { color: var(--mat-red); }

/* ── table ───────────────────────────────────────────────────── */
.mat-table-wrap {
  border: 1px solid var(--mat-border);
  border-radius: var(--mat-radius-lg);
  overflow:scroll;
  box-shadow: var(--mat-shadow-sm);
  background: #fff;
}
.mat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}
.mat-table thead th {
  padding: 10px 14px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--mat-gray-400);
  background: var(--mat-gray-100);
  border-bottom: 1px solid var(--mat-border);
  white-space: nowrap;
}
.mat-table tbody tr {
  border-bottom: 1px solid var(--mat-border);
  transition: background 0.1s;
}
.mat-table tbody tr:last-child { border-bottom: none; }
.mat-table tbody tr:hover { background: #FAFAF9; }
.mat-table tbody td { padding: 11px 14px; vertical-align: middle; }

.mat-table--compact tbody td { padding: 8px 12px; }
.mat-table--compact thead th { padding: 8px 12px; }

.mat-dm-no {
  font-family: var(--mat-font-mono);
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--mat-teal);
}
.mat-date { display: block; font-weight: 500; }
.mat-time { display: block; font-size: 0.7rem; color: var(--mat-gray-400); margin-top: 1px; }
.mat-td-site, .mat-td-supplier { max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mat-td-remark { max-width: 140px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--mat-gray-400); }
.mat-amount { text-align: right; font-variant-numeric: tabular-nums; font-weight: 500; }
.mat-amount--success { color: var(--mat-green); }
.mat-unset { color: var(--mat-gray-400); font-style: italic; }

.mat-thumb {
  width: 34px;
  height: 34px;
  object-fit: cover;
  border-radius: var(--mat-radius-sm);
  border: 1px solid var(--mat-border);
  cursor: zoom-in;
  display: block;
  margin: 0 auto;
}
.mat-no-img { color: var(--mat-gray-400); font-size: 0.75rem; }

.mat-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--mat-radius-sm);
  border: 1px solid var(--mat-border);
  background: #fff;
  color: var(--mat-gray-600);
  cursor: pointer;
  transition: all 0.13s;
}
.mat-icon-btn:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); border-color: var(--mat-border-md); }
.mat-icon-btn--danger:hover { background: var(--mat-red-light); color: var(--mat-red); border-color: var(--mat-red-mid); }

.mat-actions-cell { display: flex; align-items: center; gap: 6px; justify-content: center; }

/* ── badges ──────────────────────────────────────────────────── */
.mat-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.2px;
}
.mat-badge--neutral { background: var(--mat-gray-100); color: var(--mat-gray-600); }
.mat-badge--teal    { background: var(--mat-teal-light); color: var(--mat-teal); }
.mat-badge--amber   { background: var(--mat-amber-light); color: var(--mat-amber); }
.mat-badge--red     { background: var(--mat-red-light); color: var(--mat-red); }

/* ── empty & loading states ─────────────────────────────────── */
.mat-loading {
  display: flex; align-items: center; justify-content: center;
  gap: 12px; padding: 4rem; color: var(--mat-gray-400); font-size: 0.9rem;
}
.mat-spinner {
  width: 20px; height: 20px;
  border: 2px solid var(--mat-gray-200);
  border-top-color: var(--mat-teal);
  border-radius: 50%;
  animation: mat-spin 0.7s linear infinite;
}
@keyframes mat-spin { to { transform: rotate(360deg); } }

.mat-loading-inline {
  display: flex; align-items: center; gap: 8px;
  padding: 1.5rem; color: var(--mat-gray-400); font-size: 0.85rem;
}

.mat-empty {
  text-align: center; padding: 4rem 2rem;
  color: var(--mat-gray-400);
}
.mat-empty__icon { color: var(--mat-gray-200); margin-bottom: 1rem; }
.mat-empty h3 { font-size: 1rem; color: var(--mat-gray-600); margin: 0 0 6px; }
.mat-empty p  { font-size: 0.85rem; margin: 0; }

.mat-empty-inline {
  padding: 2rem 1.5rem; color: var(--mat-gray-400);
  font-size: 0.85rem; text-align: center;
}

.mat-empty-page {
  text-align: center; padding: 5rem 2rem;
  max-width: 480px; margin: 0 auto;
}
.mat-empty-page__icon { color: var(--mat-gray-200); margin-bottom: 1.5rem; }
.mat-empty-page h2 { font-size: 1.25rem; color: var(--mat-gray-900); margin: 0 0 8px; }
.mat-empty-page p  { color: var(--mat-gray-400); margin: 0 0 1.5rem; }

.mat-error-page {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  padding: 4rem 2rem; color: var(--mat-red); font-size: 0.9rem;
}

/* ── overlay & modal ─────────────────────────────────────────── */
.mat-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0,0,0,0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  backdrop-filter: blur(2px);
  animation: mat-fade-in 0.15s ease;
}
@keyframes mat-fade-in { from { opacity: 0; } to { opacity: 1; } }

.mat-modal {
  background: #fff;
  border-radius: var(--mat-radius-lg);
  box-shadow: var(--mat-shadow-lg);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  animation: mat-slide-up 0.18s ease;
  overflow: hidden;
}
@keyframes mat-slide-up { from { transform: translateY(10px); opacity: 0; } to { transform: none; opacity: 1; } }

.mat-modal--sm { width: 440px; }
.mat-modal--md { width: 520px; }
.mat-modal--lg { width: 780px; max-width: 95vw; }

.mat-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--mat-border);
  flex-shrink: 0;
}
.mat-modal__title {
  font-size: 0.9375rem;
  font-weight: 600;
  margin: 0;
  color: var(--mat-gray-900);
}
.mat-modal__close {
  display: flex; align-items: center; justify-content: center;
  width: 28px; height: 28px;
  border-radius: var(--mat-radius-sm);
  border: none; background: none;
  color: var(--mat-gray-400); cursor: pointer;
  transition: background 0.1s, color 0.1s;
}
.mat-modal__close:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); }

.mat-modal__body {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}
.mat-modal__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid var(--mat-border);
  flex-shrink: 0;
  background: var(--mat-gray-100);
}

.mat-modal-toolbar {
  display: flex; justify-content: flex-end; margin-bottom: 12px;
}

.mat-modal-foot-group {
  display: flex; align-items: center; gap: 8px; width: 100%;
}
.mat-modal-foot-group .mat-btn--danger { margin-left: auto; }

/* ── detail modal internals ─────────────────────────────────── */
.mat-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}
.mat-detail-item {
  background: var(--mat-gray-100);
  border-radius: var(--mat-radius-md);
  padding: 10px 12px;
}
.mat-detail-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--mat-gray-400);
  margin-bottom: 3px;
}
.mat-detail-val {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--mat-gray-900);
}
.mat-remark-box {
  background: #EAF3DE;
  border-left: 3px solid var(--mat-teal-mid);
  border-radius: 0 var(--mat-radius-sm) var(--mat-radius-sm) 0;
  padding: 10px 14px;
  font-size: 0.8125rem;
  color: var(--mat-green);
  margin-bottom: 16px;
}
.mat-section-heading {
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--mat-gray-400);
  margin: 0 0 10px;
}
.mat-total-row td {
  background: var(--mat-green-light);
  color: var(--mat-green);
  font-weight: 600;
  font-size: 0.85rem;
}

/* ── price modal ─────────────────────────────────────────────── */
.mat-price-list { display: flex; flex-direction: column; gap: 2px; }
.mat-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--mat-border);
}
.mat-price-row:last-child { border-bottom: none; }
.mat-price-name { font-size: 0.85rem; font-weight: 500; margin: 0 0 2px; }
.mat-price-meta { font-size: 0.75rem; color: var(--mat-gray-400); margin: 0; }
.mat-price-input-wrap {
  display: flex; align-items: center;
  border: 1px solid var(--mat-border-md);
  border-radius: var(--mat-radius-md);
  overflow: hidden;
  background: #fff;
}
.mat-price-prefix {
  padding: 0 8px;
  font-size: 0.8125rem;
  color: var(--mat-gray-400);
  background: var(--mat-gray-100);
  border-right: 1px solid var(--mat-border);
  height: 36px; display: flex; align-items: center;
}
.mat-price-input {
  width: 100px; height: 36px;
  border: none; outline: none;
  padding: 0 10px;
  font-size: 0.8125rem;
  text-align: right;
  font-family: var(--mat-font-mono);
}

/* ── form ─────────────────────────────────────────────────────── */
.mat-form { display: flex; flex-direction: column; gap: 16px; }
.mat-form__group label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--mat-gray-600);
  margin-bottom: 6px;
}
.mat-form__group input,
.mat-form__group select,
.mat-form__group textarea {
  width: 100%;
  padding: 0 12px;
  height: 38px;
  border: 1px solid var(--mat-border-md);
  border-radius: var(--mat-radius-md);
  font-size: 0.875rem;
  font-family: var(--mat-font);
  background: #fff;
  color: var(--mat-gray-900);
  outline: none;
  transition: border-color 0.13s, box-shadow 0.13s;
  appearance: none;
}
.mat-form__group textarea {
  height: auto; padding: 10px 12px; resize: vertical;
}
.mat-form__group input:focus,
.mat-form__group select:focus,
.mat-form__group textarea:focus {
  border-color: var(--mat-teal);
  box-shadow: 0 0 0 3px rgba(15,110,86,0.12);
}
.mat-required { color: var(--mat-red); margin-left: 2px; }

/* ── delete modal ─────────────────────────────────────────────── */
.mat-delete-body { text-align: center; padding: 8px 0 4px; }
.mat-delete-icon {
  width: 60px; height: 60px;
  background: var(--mat-red-light);
  color: var(--mat-red);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
}
.mat-delete-body p { font-size: 0.875rem; color: var(--mat-gray-600); line-height: 1.6; margin: 0; }
.mat-delete-body strong { color: var(--mat-gray-900); }

/* ── image viewer ─────────────────────────────────────────────── */
.mat-image-viewer {
  position: fixed; inset: 0; z-index: 300;
  background: rgba(0,0,0,0.85);
  display: flex; align-items: center; justify-content: center;
  cursor: zoom-out;
  animation: mat-fade-in 0.15s ease;
}
.mat-image-viewer img {
  max-width: 90vw; max-height: 90vh;
  border-radius: var(--mat-radius-lg);
  box-shadow: 0 24px 64px rgba(0,0,0,0.5);
  cursor: default;
}
.mat-image-viewer__close {
  position: absolute; top: 1.25rem; right: 1.25rem;
  width: 36px; height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.25);
  color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.13s;
}
.mat-image-viewer__close:hover { background: rgba(255,255,255,0.25); }

/* ── responsive ──────────────────────────mat-table-wrap─────────────────────── */
@media (max-width: 768px) {
  .mat-page { padding: 1rem 1rem 2rem; }
  .mat-header { flex-direction: column; align-items: stretch; }
  .mat-header__actions { flex-wrap: wrap; }
  .mat-stats { grid-template-columns: 1fr; gap: 8px; }
  .mat-detail-grid { grid-template-columns: 1fr; }
  .mat-modal--md, .mat-modal--lg { width: 95vw; }
  .mat-table { font-size: 0.75rem; }
  .mat-table thead th,
  .mat-table tbody td { padding: 8px 10px; }
}



/* ──────────────────────────────────────────────────────
   ADD THESE CLASSES TO YOUR EXISTING material.css
   (paste at the bottom of the file)
   ────────────────────────────────────────────────────── */

/* Inline material items list inside the main table */
.mat-items-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  max-width: 300px;
}

.mat-item-chip {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 4px 8px;
  background: #f0fdf8;
  border-left: 2px solid #1D9E75;
  border-radius: 3px;
}

.mat-item-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #0F6E56;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}

.mat-item-meta {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.3;
}

/* Dark mode */
@media (prefers-color-scheme: dark) {
  .mat-item-chip {
    background: rgba(29, 158, 117, 0.12);
    border-left-color: #5DCAA5;
  }
  .mat-item-name {
    color: #9FE1CB;
  }
  .mat-item-meta {
    color: #888780;
  }
}

/* ═══════════════════════════════════════════════════════════════
   ADD MATERIAL FORM (am-*) — responsive redesign for AddMaterial.jsx
   Namespaced tokens (--am-*) so they never override the --radius /
   --danger / etc. tokens already defined above in this file.
   ═══════════════════════════════════════════════════════════════ */

:root {
  --am-ink: #14213d;
  --am-blueprint: #1d3557;
  --am-amber: #e8a33d;
  --am-amber-dark: #c9861f;
  --am-canvas: #f5f7fa;
  --am-card: #ffffff;
  --am-line: #e2e8f0;
  --am-muted: #64748b;
  --am-danger: #dc2626;
  --am-danger-bg: #fef2f2;
  --am-radius: 10px;
  --am-font: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

/* ---- Page shell ---- */
.am-page {
  min-height: 100vh;
  background: var(--am-canvas);
  padding: clamp(16px, 4vw, 48px);
  font-family: var(--am-font);
  color: var(--am-ink);
  box-sizing: border-box;
}

.am-card {
  max-width: 880px;
  margin: 0 auto;
  background: var(--am-card);
  border: 1px solid var(--am-line);
  border-radius: var(--am-radius);
  padding: clamp(20px, 4vw, 40px);
}

/* ---- Header ---- */
.am-header {
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--am-line);
}

.am-eyebrow {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: var(--am-blueprint);
  margin-bottom: 8px;
}

.am-header h1 {
  margin: 0 0 6px;
  font-size: clamp(22px, 3vw, 28px);
  font-weight: 700;
  letter-spacing: -0.01em;
}

.am-header p {
  margin: 0;
  color: var(--am-muted);
  font-size: 14.5px;
}

/* ---- Alert ---- */
.am-alert {
  background: var(--am-danger-bg);
  color: var(--am-danger);
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 20px;
}

/* ---- Sections ---- */
.am-section {
  margin-bottom: 32px;
}

.am-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.am-section-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--am-ink);
  margin: 0 0 16px;
}

.am-section-head .am-section-title {
  margin: 0;
}

.am-total-pill {
  font-size: 13.5px;
  color: var(--am-muted);
  background: var(--am-canvas);
  border: 1px solid var(--am-line);
  border-radius: 999px;
  padding: 6px 14px;
  margin-bottom: 16px;
}

.am-total-pill strong {
  color: var(--am-ink);
  font-size: 15px;
}

/* ---- Fields ---- */
.am-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.am-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.am-field label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--am-muted);
}

.am-field input,
.am-field select,
.am-field textarea {
  font-family: var(--am-font);
  font-size: 14.5px;
  color: var(--am-ink);
  background: var(--am-card);
  border: 1px solid var(--am-line);
  border-radius: 8px;
  padding: 10px 12px;
  /* width: 100%; */
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.am-field input:disabled,
.am-field select:disabled {
  background: var(--am-canvas);
  color: var(--am-muted);
  cursor: not-allowed;
}

.am-field input:focus-visible,
.am-field select:focus-visible,
.am-field textarea:focus-visible {
  outline: none;
  border-color: var(--am-blueprint);
  box-shadow: 0 0 0 3px rgba(29, 53, 87, 0.15);
}

.am-field textarea {
  resize: vertical;
  min-height: 76px;
}

.am-field-static {
  justify-content: flex-end;
}

.am-static-label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--am-muted);
}

.am-static-value {
  font-size: 15px;
  font-weight: 700;
  color: var(--am-ink);
  padding: 10px 0;
}

/* File input styled as a button-like drop target */
.am-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.am-file {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--am-muted);
  border: 1px dashed var(--am-line);
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.am-file:hover {
  border-color: var(--am-blueprint);
  color: var(--am-blueprint);
}

/* ---- Material items ---- */
.am-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.am-item {
  border: 1px solid var(--am-line);
  border-radius: var(--am-radius);
  padding: 16px;
  background: var(--am-canvas);
}

.am-item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 14px;
  margin-bottom: 12px;
}

.am-remove {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--am-danger);
  font-size: 13px;
  font-weight: 600;
  padding: 4px 0;
  cursor: pointer;
}

.am-remove:disabled {
  color: var(--am-muted);
  cursor: not-allowed;
}

.am-add-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  background: none;
  border: 1px dashed var(--am-blueprint);
  color: var(--am-blueprint);
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.am-add-row:hover {
  background: rgba(29, 53, 87, 0.06);
}

/* ---- Footer ---- */
.am-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid var(--am-line);
}

.am-submit {
  background: var(--am-amber);
  color: var(--am-ink);
  border: none;
  font-size: 15px;
  font-weight: 700;
  border-radius: 8px;
  padding: 12px 28px;
  cursor: pointer;
  transition: background 0.15s ease;
  width: 100%;
}

.am-submit:hover:not(:disabled) {
  background: var(--am-amber-dark);
}

.am-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ---- Responsive tweaks ---- */
@media (min-width: 480px) {
  .am-submit {
    width: auto;
  }
}

@media (max-width: 480px) {
  .am-card {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }

  .am-page {
    padding: 0;
  }

  .am-item-grid {
    grid-template-columns: 1fr 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Material/material.css"],"names":[],"mappings":"AAAA,gGAAgG;;AAEhG,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;AACnE;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yEAAyE;EACzE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wBAAwB,8BAA8B,EAAE;AACxD,wBAAwB,8BAA8B,EAAE;AACxD,wBAAwB,8BAA8B,EAAE;;AAExD,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB,aAAa,EAAE;EACxC;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,wCAAwC;EAC1C;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;;EAEE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;EACE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,2CAA2C;EAC3C,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,iBAAiB,0BAA0B,EAAE,YAAY,EAAE;AAC3D,iBAAiB,0BAA0B,EAAE,YAAY,EAAE;AAC3D,iBAAiB,yBAAyB,EAAE,YAAY,EAAE;;AAE1D;EACE,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE,mEAAmE;AACnE,mEAAmE;;AAEnE;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;AA2BA,0DAA0D;;;AAG1D;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;;oEAEoE;;AAEpE,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,qCAAqC;EACrC,qCAAqC;;EAErC,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,2EAA2E;EAC3E,4EAA4E;EAC5E,8EAA8E;;EAE9E,oEAAoE;EACpE,uDAAuD;AACzD;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,0BAA0B;EAC1B,kEAAkE;EAClE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,kBAAkB,+BAA+B,EAAE;AACnD,kBAAkB,sBAAsB,EAAE;;AAE1C;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA,0BAA0B,iCAAiC,EAAE,mCAAmC,EAAE;;AAElG;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,wBAAwB,+BAA+B,EAAE,0BAA0B,EAAE;;AAErF;EACE,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;AACvB;AACA,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;EACX,mCAAmC;AACrC;AACA,sBAAsB,iCAAiC,EAAE;;AAEzD,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,uCAAuC,+BAA+B,EAAE,0BAA0B,EAAE;AACpG,uCAAuC,kCAAkC,EAAE,uBAAuB,EAAE;AACpG,uCAAuC,gCAAgC,IAAI,qBAAqB,IAAI;;AAEpG;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;AACA,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,qBAAqB,EAAE;;AAE/D,mEAAmE;AACnE;EACE,mCAAmC;EACnC,mCAAmC;EACnC,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA,iCAAiC,mBAAmB,EAAE;AACtD,4BAA4B,mBAAmB,EAAE;AACjD,sBAAsB,kBAAkB,EAAE,sBAAsB,EAAE;;AAElE,+BAA+B,iBAAiB,EAAE;AAClD,+BAA+B,iBAAiB,EAAE;;AAElD;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,YAAY,cAAc,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC5F,iCAAiC,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACnH,iBAAiB,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,0BAA0B,EAAE;AAC/H,cAAc,iBAAiB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AACvF,uBAAuB,uBAAuB,EAAE;AAChD,aAAa,0BAA0B,EAAE,kBAAkB,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,cAAc,0BAA0B,EAAE,kBAAkB,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,+BAA+B,EAAE,0BAA0B,EAAE,kCAAkC,EAAE;AACvH,8BAA8B,gCAAgC,EAAE,qBAAqB,EAAE,gCAAgC,EAAE;;AAEzH,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,uBAAuB,EAAE;;AAE3F,mEAAmE;AACnE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,sBAAsB,+BAA+B,EAAE,0BAA0B,EAAE;AACnF,sBAAsB,iCAAiC,EAAE,sBAAsB,EAAE;AACjF,sBAAsB,kCAAkC,EAAE,uBAAuB,EAAE;AACnF,sBAAsB,gCAAgC,EAAE,qBAAqB,EAAE;;AAE/E,kEAAkE;AAClE;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,SAAS,EAAE,aAAa,EAAE,0BAA0B,EAAE,iBAAiB;AACzE;AACA;EACE,WAAW,EAAE,YAAY;EACzB,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,0BAA0B,EAAE,kBAAkB;AACjE;;AAEA;EACE,kBAAkB,EAAE,kBAAkB;EACtC,0BAA0B;AAC5B;AACA,mBAAmB,0BAA0B,EAAE,mBAAmB,EAAE;AACpE,gBAAgB,eAAe,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC9E,gBAAgB,kBAAkB,EAAE,SAAS,EAAE;;AAE/C;EACE,oBAAoB,EAAE,0BAA0B;EAChD,kBAAkB,EAAE,kBAAkB;AACxC;;AAEA;EACE,kBAAkB,EAAE,kBAAkB;EACtC,gBAAgB,EAAE,cAAc;AAClC;AACA,wBAAwB,0BAA0B,EAAE,qBAAqB,EAAE;AAC3E,qBAAqB,kBAAkB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtF,qBAAqB,0BAA0B,EAAE,kBAAkB,EAAE;;AAErE;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS;EACtE,kBAAkB,EAAE,qBAAqB,EAAE,iBAAiB;AAC9D;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;AACnC;AACA,yBAAyB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEjE;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;AACA,0BAA0B,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,eAAe,EAAE,UAAU,EAAE,EAAE;;AAEhH,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE;AAC/B,iBAAiB,YAAY,EAAE,eAAe,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW,EAAE,YAAY;EACzB,mCAAmC;EACnC,YAAY,EAAE,gBAAgB;EAC9B,0BAA0B,EAAE,eAAe;EAC3C,uCAAuC;AACzC;AACA,0BAA0B,+BAA+B,EAAE,0BAA0B,EAAE;;AAEvF;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB;AAC/D;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW;AAC3D;AACA,yCAAyC,iBAAiB,EAAE;;AAE5D,kEAAkE;AAClE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,4DAA4D;EAC5D,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0CAA0C;AAC5C;AACA,4BAA4B,mBAAmB,EAAE;AACjD,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACzE,kBAAkB,kBAAkB,EAAE,0BAA0B,EAAE,SAAS,EAAE;AAC7E;EACE,aAAa,EAAE,mBAAmB;EAClC,sCAAsC;EACtC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;EAC/B,yCAAyC;EACzC,YAAY,EAAE,aAAa,EAAE,mBAAmB;AAClD;AACA;EACE,YAAY,EAAE,YAAY;EAC1B,YAAY,EAAE,aAAa;EAC3B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,oEAAoE;AACpE,YAAY,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC9D;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;AACA;EACE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;AACpD;AACA;;;EAGE,6BAA6B;EAC7B,0CAA0C;AAC5C;AACA,gBAAgB,qBAAqB,EAAE,gBAAgB,EAAE;;AAEzD,oEAAoE;AACpE,mBAAmB,kBAAkB,EAAE,kBAAkB,EAAE;AAC3D;EACE,WAAW,EAAE,YAAY;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;AACrB;AACA,qBAAqB,mBAAmB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACnG,0BAA0B,0BAA0B,EAAE;;AAEtD,oEAAoE;AACpE;EACE,eAAe,EAAE,QAAQ,EAAE,YAAY;EACvC,4BAA4B;EAC5B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,kBAAkB,EAAE,YAAY,EAAE,cAAc;EAChD,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,WAAW,EAAE,eAAe;EAC5B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,4BAA4B;AAC9B;AACA,iCAAiC,kCAAkC,EAAE;;AAErE,kFAAkF;AAClF;EACE,YAAY,uBAAuB,EAAE;EACrC,cAAc,sBAAsB,EAAE,oBAAoB,EAAE;EAC5D,uBAAuB,eAAe,EAAE;EACxC,aAAa,0BAA0B,EAAE,QAAQ,EAAE;EACnD,mBAAmB,0BAA0B,EAAE;EAC/C,iCAAiC,WAAW,EAAE;EAC9C,aAAa,kBAAkB,EAAE;EACjC;wBACsB,iBAAiB,EAAE;AAC3C;;;;AAIA;;;2DAG2D;;AAE3D,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;;;oEAIoE;;AAEpE;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,6EAA6E;AAC/E;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;;EAEE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* material.css - Complete file with preserved table design + enhanced payment modal & filters */\n\n/* ────────────────────────────────────────────────────────────── */\n/*                        ROOT VARIABLES                          */\n/* ────────────────────────────────────────────────────────────── */\n:root {\n  --primary: #14b8a6;\n  --primary-dark: #0d8a7b;\n  --primary-light: #ecfdf9;\n  --success: #16a34a;\n  --danger: #dc2626;\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-600: #4b5563;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --radius: 12px;\n  --shadow: 0 4px 16px rgba(0,0,0,0.08);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.material-wrapper {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.page-title {\n  font-size: 2.4rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--gray-800), var(--primary-dark));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.page-subtitle {\n  color: var(--gray-600);\n  margin-top: 0.4rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* ────────────────────────────────────────────────────────────── */\n/*                    IMPROVED FILTERS & BUTTONS                  */\n/* ────────────────────────────────────────────────────────────── */\n\n.filter-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  border: 1px solid var(--gray-300);\n  border-radius: 8px;\n  padding: 0 12px;\n  height: 42px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  transition: all 0.2s;\n}\n\n.filter-box:hover,\n.filter-box:focus-within {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(20,184,166,0.1);\n}\n\n.filter-box select {\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: var(--gray-700);\n  cursor: pointer;\n  min-width: 140px;\n}\n\n/* Record Payment & Export Buttons */\n.record-payment-btn,\n.export-excel-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 7px;\n  border-radius: 8px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.record-payment-btn {\n  background: var(--primary);\n  color: white;\n}\n\n.record-payment-btn:hover {\n  background: var(--primary-dark);\n  transform: translateY(-2px);\n}\n\n.export-excel-btn {\n  background: #f59e0b;\n  color: white;\n}\n\n.export-excel-btn:hover {\n  background: #d97706;\n  transform: translateY(-2px);\n}\n\n.fab-btn {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 20px rgba(20,184,166,0.3);\n  transition: all 0.3s;\n  text-decoration: none;\n}\n\n.fab-btn:hover {\n  transform: translateY(-4px);\n}\n\n/* ────────────────────────────────────────────────────────────── */\n/*                  MODERN FINANCIAL CARDS                        */\n/* ────────────────────────────────────────────────────────────── */\n\n.financial-overview-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n  margin: 1.5rem 0 2.5rem;\n}\n\n.finance-card {\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem 1.75rem;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.finance-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);\n}\n\n.finance-label {\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin-bottom: 0.6rem;\n}\n\n.finance-value {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.finance-card.total   { border-left: 5px solid #3b82f6; }\n.finance-card.paid    { border-left: 5px solid #10b981; }\n.finance-card.balance { border-left: 5px solid #ef4444; }\n\n/* ────────────────────────────────────────────────────────────── */\n/*               PRESERVED ORIGINAL TABLE DESIGN                  */\n/* ────────────────────────────────────────────────────────────── */\n\n.table-responsive {\n  overflow-x: auto;\n  background: white;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n}\n\n.materials-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 900px;\n}\n\n.materials-table th,\n.materials-table td {\n  padding: 1rem 1.1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.materials-table th {\n  background: var(--primary-light);\n  color: var(--gray-700);\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n}\n\n.materials-table tbody tr:hover {\n  background: rgba(20,184,166,0.05);\n}\n\n.amount {\n  font-weight: 600;\n  color: var(--success);\n}\n\n.image-cell {\n  text-align: center;\n}\n\n.thumbnail {\n  width: 80px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.no-image {\n  color: var(--gray-500);\n  font-size: 0.85rem;\n}\n\n.action-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid var(--gray-300);\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.action-btn.view {\n  background: var(--primary-light);\n  color: var(--primary-dark);\n  border-color: var(--primary);\n}\n\n/* Mobile stacked layout - PRESERVED */\n@media (max-width: 992px) {\n  .materials-table thead { display: none; }\n  .materials-table tr {\n    display: block;\n    margin-bottom: 1.5rem;\n    background: white;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow);\n    padding: 1rem;\n  }\n  .materials-table td {\n    display: flex;\n    justify-content: space-between;\n    border: none;\n    padding: 0.8rem 1rem;\n    border-bottom: 1px solid var(--gray-100);\n  }\n  .materials-table td:last-child {\n    border-bottom: none;\n    justify-content: center;\n  }\n  .materials-table td:before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: var(--gray-700);\n    flex: 0 0 40%;\n    padding-right: 1rem;\n  }\n}\n\n/* ────────────────────────────────────────────────────────────── */\n/*                        MODALS - BASE                           */\n/* ────────────────────────────────────────────────────────────── */\n\n.modal-backdrop.deluxe,\n.image-viewer {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.8);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.modal-card.deluxe {\n  background: white;\n  border-radius: 20px;\n  max-width: 600px;\n  width: 92%;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.3);\n}\n\n.modal-card.deluxe.large {\n  max-width: 900px;\n}\n\n.modal-header.deluxe {\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: white;\n  padding: 1.6rem 2rem;\n  position: relative;\n}\n\n.close-btn.deluxe {\n  position: absolute;\n  top: 1rem;\n  right: 1.5rem;\n  background: rgba(255,255,255,0.3);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n}\n\n.modal-body {\n  padding: 1.8rem;\n  max-height: 65vh;\n  overflow-y: auto;\n}\n\n/* ────────────────────────────────────────────────────────────── */\n/*         ENHANCED PAYMENT MANAGEMENT MODAL ONLY                 */\n/* ────────────────────────────────────────────────────────────── */\n\n.payment-management-modal .modal-card.deluxe {\n  max-width: 960px;\n}\n\n.payment-management-modal .modal-header.deluxe {\n  background: linear-gradient(135deg, #0f766e, #0d8a7b);\n}\n\n.payment-management-modal h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n.payment-management-modal .modal-body {\n  padding: 2rem;\n  background: #f8fafc;\n}\n\n.payments-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 8px;\n  margin: 1.5rem 0;\n}\n\n.payments-table thead th {\n  background: #e0f2f1;\n  color: #0d8a7b;\n  font-weight: 600;\n  font-size: 0.85rem;\n  padding: 1rem;\n  border: none;\n}\n\n.payments-table tbody tr {\n  background: white;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  border-radius: 10px;\n  transition: all 0.2s;\n}\n\n.payments-table tbody tr:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0,0,0,0.1);\n}\n\n.payments-table td {\n  padding: 1.1rem;\n  border: none;\n}\n\n.payments-table td:nth-child(2) {\n  font-weight: 700;\n  color: var(--success);\n  font-size: 1.1rem;\n}\n\n.payment-form {\n  background: white;\n  border-radius: 12px;\n  padding: 1.6rem;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.05);\n  margin-top: 1.5rem;\n}\n\n.payment-form .form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.4rem;\n}\n\n.payment-form .full-width {\n  grid-column: 1 / -1;\n}\n\n.payment-form label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.payment-form input,\n.payment-form textarea {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  border: 1px solid var(--gray-300);\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.payment-form input:focus,\n.payment-form textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(20,184,166,0.15);\n  outline: none;\n}\n\n/* Modal Actions */\n.modal-actions.deluxe.multiple {\n  padding: 1.5rem 2rem;\n  background: #f8fafc;\n  border-top: 1px solid var(--gray-200);\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.modal-actions button {\n  padding: 0.8rem 1.6rem;\n  border-radius: 8px;\n  font-weight: 600;\n  min-width: 140px;\n  transition: all 0.2s;\n}\n\n.btn-secondary { background: #6b7280; color: white; }\n.btn-success   { background: var(--success); color: white; }\n.btn-primary   { background: var(--primary); color: white; }\n.btn-danger    { background: var(--danger); color: white; }\n\n.btn-ghost {\n  background: transparent;\n  border: 2px solid var(--gray-300);\n  color: var(--gray-700);\n}\n\n/* ────────────────────────────────────────────────────────────── */\n/*                        OTHER ELEMENTS                          */\n/* ────────────────────────────────────────────────────────────── */\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.2rem;\n  margin-bottom: 1.5rem;\n}\n\n.detail-grid div {\n  background: #f8fafc;\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.remark-box {\n  background: #ecfdf5;\n  padding: 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #10b981;\n}\n\n.items-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.items-table th,\n.items-table td {\n  padding: 0.9rem;\n  text-align: left;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.total-row td {\n  padding-top: 1rem;\n  font-size: 1.1rem;\n}\n\n.price-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.price-row input {\n  width: 120px;\n  padding: 0.7rem;\n  border: 2px solid var(--gray-300);\n  border-radius: 10px;\n  text-align: right;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 5rem 2rem;\n  color: var(--gray-600);\n}\n\n.empty-icon {\n  color: var(--gray-400);\n  margin-bottom: 1.5rem;\n}\n\n.loader, .error-msg {\n  text-align: center;\n  padding: 5rem;\n  font-size: 1.3rem;\n}\n\n.image-viewer img {\n  max-width: 94vw;\n  max-height: 90vh;\n  border-radius: 12px;\n  box-shadow: 0 15px 40px rgba(0,0,0,0.4);\n}\n\n.close-image {\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  background: rgba(0,0,0,0.6);\n  color: white;\n  border: none;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.8rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .payment-form .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ============= PREMIUM ADD MATERIAL FORM ============= */\n\n\n.page-container {\n  background: #f2f4f7;\n  min-height: 100vh;\n  padding: 30px;\n}\n\n.page-card {\n  max-width: 1200px;\n  margin: auto;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n}\n\n.page-header h2 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 600;\n}\n\n.page-header p {\n  margin: 4px 0 25px;\n  color: #777;\n  font-size: 14px;\n}\n\n.section {\n  margin-bottom: 30px;\n}\n\n.section-title {\n  font-size: 18px;\n  margin-bottom: 15px;\n  color: #222;\n  border-left: 4px solid #0d6efd;\n  padding-left: 10px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n}\n\n.field.full {\n  margin-top: 15px;\n}\n\n.field label {\n  font-size: 13px;\n  color: #555;\n  margin-bottom: 6px;\n}\n\ninput,\nselect,\ntextarea {\n  padding: 9px 12px;\n  border-radius: 6px;\n  border: 1px solid #d0d5dd;\n  font-size: 14px;\n}\n\n.material-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.material-head,\n.material-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 0.5fr;\n  gap: 12px;\n  padding: 10px;\n  align-items: center;\n}\n\n.material-head {\n  background: #f9fafb;\n  font-weight: 600;\n  font-size: 13px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.material-row {\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.material-row:last-child {\n  border-bottom: none;\n}\n\n.total {\n  font-weight: 600;\n  color: #111;\n}\n\n.delete-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #dc3545;\n}\n\n.add-row-btn {\n  margin-top: 15px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #eef2ff;\n  border: 1px dashed #6366f1;\n  color: #3730a3;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n}\n\n.footer button {\n  background: #0d6efd;\n  color: #fff;\n  padding: 10px 30px;\n  border-radius: 8px;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.alert-error {\n  background: #fee2e2;\n  color: #991b1b;\n  padding: 10px;\n  border-radius: 6px;\n  margin-bottom: 15px;\n}\n\n\n/* ═══════════════════════════════════════════════════════════════\n   material.css  —  Professional redesign\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── tokens ─────────────────────────────────────────────────── */\n:root {\n  --mat-teal:          #0F6E56;\n  --mat-teal-hover:    #085041;\n  --mat-teal-light:    #E1F5EE;\n  --mat-teal-mid:      #5DCAA5;\n\n  --mat-red:           #993C1D;\n  --mat-red-light:     #FAECE7;\n  --mat-red-mid:       #F0997B;\n\n  --mat-green:         #3B6D11;\n  --mat-green-light:   #EAF3DE;\n\n  --mat-amber-light:   #FAEEDA;\n  --mat-amber:         #BA7517;\n\n  --mat-gray-100:      #F5F4F1;\n  --mat-gray-200:      #E8E7E3;\n  --mat-gray-400:      #A8A7A0;\n  --mat-gray-600:      #5F5E5A;\n  --mat-gray-900:      #1A1A18;\n\n  --mat-border:        rgba(0,0,0,0.08);\n  --mat-border-md:     rgba(0,0,0,0.13);\n\n  --mat-radius-sm:     6px;\n  --mat-radius-md:     8px;\n  --mat-radius-lg:     12px;\n\n  --mat-shadow-sm:     0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.05);\n  --mat-shadow-md:     0 4px 16px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06);\n  --mat-shadow-lg:     0 12px 40px rgba(0,0,0,0.14), 0 4px 12px rgba(0,0,0,0.08);\n\n  --mat-font:          'DM Sans', system-ui, -apple-system, sans-serif;\n  --mat-font-mono:     'DM Mono', ui-monospace, monospace;\n}\n\n/* ── page shell ─────────────────────────────────────────────── */\n.mat-page {\n  font-family: var(--mat-font);\n  color: var(--mat-gray-900);\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem 3rem;\n}\n\n/* ── page header ─────────────────────────────────────────────── */\n.mat-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.75rem;\n  flex-wrap: wrap;\n}\n.mat-header__title {\n  font-size: 1.375rem;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  color: var(--mat-gray-900);\n  margin: 0;\n}\n.mat-header__sub {\n  font-size: 0.8125rem;\n  color: var(--mat-gray-400);\n  margin: 3px 0 0;\n}\n.mat-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* ── buttons ─────────────────────────────────────────────────── */\n.mat-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px;\n  height: 36px;\n  border-radius: var(--mat-radius-md);\n  font-size: 0.8125rem;\n  font-weight: 500;\n  font-family: var(--mat-font);\n  cursor: pointer;\n  border: 1px solid var(--mat-border-md);\n  background: #fff;\n  color: var(--mat-gray-900);\n  transition: background 0.13s, border-color 0.13s, box-shadow 0.13s;\n  white-space: nowrap;\n  text-decoration: none;\n}\n.mat-btn:hover  { background: var(--mat-gray-100); }\n.mat-btn:active { transform: scale(0.98); }\n\n.mat-btn--primary {\n  background: var(--mat-teal);\n  border-color: var(--mat-teal);\n  color: #fff;\n}\n.mat-btn--primary:hover { background: var(--mat-teal-hover); border-color: var(--mat-teal-hover); }\n\n.mat-btn--ghost {\n  background: transparent;\n  border-color: var(--mat-border);\n  color: var(--mat-gray-600);\n}\n.mat-btn--ghost:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); }\n\n.mat-btn--danger {\n  background: var(--mat-red-light);\n  border-color: var(--mat-red-mid);\n  color: var(--mat-red);\n}\n.mat-btn--danger:hover { background: #F5C4B3; }\n\n.mat-btn--fab {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  justify-content: center;\n  background: var(--mat-teal);\n  border-color: var(--mat-teal);\n  color: #fff;\n  border-radius: var(--mat-radius-md);\n}\n.mat-btn--fab:hover { background: var(--mat-teal-hover); }\n\n/* ── filter ──────────────────────────────────────────────────── */\n.mat-filter {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--mat-border-md);\n  border-radius: var(--mat-radius-md);\n  background: #fff;\n  color: var(--mat-gray-600);\n  font-size: 0.8125rem;\n  position: relative;\n}\n.mat-filter select {\n  border: none;\n  background: transparent;\n  font-size: 0.8125rem;\n  color: var(--mat-gray-900);\n  outline: none;\n  cursor: pointer;\n  padding-right: 16px;\n  appearance: none;\n  font-family: var(--mat-font);\n}\n.mat-filter__chevron {\n  position: absolute;\n  right: 8px;\n  pointer-events: none;\n  color: var(--mat-gray-400);\n}\n\n/* ── stat cards ──────────────────────────────────────────────── */\n.mat-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 1.75rem;\n}\n.stat-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 1rem 1.25rem;\n  border-radius: var(--mat-radius-lg);\n  border: 1px solid var(--mat-border);\n  background: #fff;\n  box-shadow: var(--mat-shadow-sm);\n}\n.stat-card__icon {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--mat-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.stat-card--neutral .stat-card__icon { background: var(--mat-gray-100); color: var(--mat-gray-600); }\n.stat-card--success .stat-card__icon { background: var(--mat-green-light); color: var(--mat-green); }\n.stat-card--danger  .stat-card__icon { background: var(--mat-red-light);   color: var(--mat-red);   }\n\n.stat-card__label {\n  font-size: 0.75rem;\n  color: var(--mat-gray-400);\n  margin: 0 0 3px;\n}\n.stat-card__value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0;\n  color: var(--mat-gray-900);\n}\n.stat-card--success .stat-card__value { color: var(--mat-green); }\n.stat-card--danger  .stat-card__value { color: var(--mat-red); }\n\n/* ── table ───────────────────────────────────────────────────── */\n.mat-table-wrap {\n  border: 1px solid var(--mat-border);\n  border-radius: var(--mat-radius-lg);\n  overflow:scroll;\n  box-shadow: var(--mat-shadow-sm);\n  background: #fff;\n}\n.mat-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n.mat-table thead th {\n  padding: 10px 14px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--mat-gray-400);\n  background: var(--mat-gray-100);\n  border-bottom: 1px solid var(--mat-border);\n  white-space: nowrap;\n}\n.mat-table tbody tr {\n  border-bottom: 1px solid var(--mat-border);\n  transition: background 0.1s;\n}\n.mat-table tbody tr:last-child { border-bottom: none; }\n.mat-table tbody tr:hover { background: #FAFAF9; }\n.mat-table tbody td { padding: 11px 14px; vertical-align: middle; }\n\n.mat-table--compact tbody td { padding: 8px 12px; }\n.mat-table--compact thead th { padding: 8px 12px; }\n\n.mat-dm-no {\n  font-family: var(--mat-font-mono);\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--mat-teal);\n}\n.mat-date { display: block; font-weight: 500; }\n.mat-time { display: block; font-size: 0.7rem; color: var(--mat-gray-400); margin-top: 1px; }\n.mat-td-site, .mat-td-supplier { max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.mat-td-remark { max-width: 140px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--mat-gray-400); }\n.mat-amount { text-align: right; font-variant-numeric: tabular-nums; font-weight: 500; }\n.mat-amount--success { color: var(--mat-green); }\n.mat-unset { color: var(--mat-gray-400); font-style: italic; }\n\n.mat-thumb {\n  width: 34px;\n  height: 34px;\n  object-fit: cover;\n  border-radius: var(--mat-radius-sm);\n  border: 1px solid var(--mat-border);\n  cursor: zoom-in;\n  display: block;\n  margin: 0 auto;\n}\n.mat-no-img { color: var(--mat-gray-400); font-size: 0.75rem; }\n\n.mat-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: var(--mat-radius-sm);\n  border: 1px solid var(--mat-border);\n  background: #fff;\n  color: var(--mat-gray-600);\n  cursor: pointer;\n  transition: all 0.13s;\n}\n.mat-icon-btn:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); border-color: var(--mat-border-md); }\n.mat-icon-btn--danger:hover { background: var(--mat-red-light); color: var(--mat-red); border-color: var(--mat-red-mid); }\n\n.mat-actions-cell { display: flex; align-items: center; gap: 6px; justify-content: center; }\n\n/* ── badges ──────────────────────────────────────────────────── */\n.mat-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 99px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n}\n.mat-badge--neutral { background: var(--mat-gray-100); color: var(--mat-gray-600); }\n.mat-badge--teal    { background: var(--mat-teal-light); color: var(--mat-teal); }\n.mat-badge--amber   { background: var(--mat-amber-light); color: var(--mat-amber); }\n.mat-badge--red     { background: var(--mat-red-light); color: var(--mat-red); }\n\n/* ── empty & loading states ─────────────────────────────────── */\n.mat-loading {\n  display: flex; align-items: center; justify-content: center;\n  gap: 12px; padding: 4rem; color: var(--mat-gray-400); font-size: 0.9rem;\n}\n.mat-spinner {\n  width: 20px; height: 20px;\n  border: 2px solid var(--mat-gray-200);\n  border-top-color: var(--mat-teal);\n  border-radius: 50%;\n  animation: mat-spin 0.7s linear infinite;\n}\n@keyframes mat-spin { to { transform: rotate(360deg); } }\n\n.mat-loading-inline {\n  display: flex; align-items: center; gap: 8px;\n  padding: 1.5rem; color: var(--mat-gray-400); font-size: 0.85rem;\n}\n\n.mat-empty {\n  text-align: center; padding: 4rem 2rem;\n  color: var(--mat-gray-400);\n}\n.mat-empty__icon { color: var(--mat-gray-200); margin-bottom: 1rem; }\n.mat-empty h3 { font-size: 1rem; color: var(--mat-gray-600); margin: 0 0 6px; }\n.mat-empty p  { font-size: 0.85rem; margin: 0; }\n\n.mat-empty-inline {\n  padding: 2rem 1.5rem; color: var(--mat-gray-400);\n  font-size: 0.85rem; text-align: center;\n}\n\n.mat-empty-page {\n  text-align: center; padding: 5rem 2rem;\n  max-width: 480px; margin: 0 auto;\n}\n.mat-empty-page__icon { color: var(--mat-gray-200); margin-bottom: 1.5rem; }\n.mat-empty-page h2 { font-size: 1.25rem; color: var(--mat-gray-900); margin: 0 0 8px; }\n.mat-empty-page p  { color: var(--mat-gray-400); margin: 0 0 1.5rem; }\n\n.mat-error-page {\n  display: flex; align-items: center; justify-content: center; gap: 10px;\n  padding: 4rem 2rem; color: var(--mat-red); font-size: 0.9rem;\n}\n\n/* ── overlay & modal ─────────────────────────────────────────── */\n.mat-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(0,0,0,0.32);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  animation: mat-fade-in 0.15s ease;\n}\n@keyframes mat-fade-in { from { opacity: 0; } to { opacity: 1; } }\n\n.mat-modal {\n  background: #fff;\n  border-radius: var(--mat-radius-lg);\n  box-shadow: var(--mat-shadow-lg);\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  animation: mat-slide-up 0.18s ease;\n  overflow: hidden;\n}\n@keyframes mat-slide-up { from { transform: translateY(10px); opacity: 0; } to { transform: none; opacity: 1; } }\n\n.mat-modal--sm { width: 440px; }\n.mat-modal--md { width: 520px; }\n.mat-modal--lg { width: 780px; max-width: 95vw; }\n\n.mat-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--mat-border);\n  flex-shrink: 0;\n}\n.mat-modal__title {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--mat-gray-900);\n}\n.mat-modal__close {\n  display: flex; align-items: center; justify-content: center;\n  width: 28px; height: 28px;\n  border-radius: var(--mat-radius-sm);\n  border: none; background: none;\n  color: var(--mat-gray-400); cursor: pointer;\n  transition: background 0.1s, color 0.1s;\n}\n.mat-modal__close:hover { background: var(--mat-gray-100); color: var(--mat-gray-900); }\n\n.mat-modal__body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n.mat-modal__foot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--mat-border);\n  flex-shrink: 0;\n  background: var(--mat-gray-100);\n}\n\n.mat-modal-toolbar {\n  display: flex; justify-content: flex-end; margin-bottom: 12px;\n}\n\n.mat-modal-foot-group {\n  display: flex; align-items: center; gap: 8px; width: 100%;\n}\n.mat-modal-foot-group .mat-btn--danger { margin-left: auto; }\n\n/* ── detail modal internals ─────────────────────────────────── */\n.mat-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n.mat-detail-item {\n  background: var(--mat-gray-100);\n  border-radius: var(--mat-radius-md);\n  padding: 10px 12px;\n}\n.mat-detail-label {\n  display: block;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--mat-gray-400);\n  margin-bottom: 3px;\n}\n.mat-detail-val {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--mat-gray-900);\n}\n.mat-remark-box {\n  background: #EAF3DE;\n  border-left: 3px solid var(--mat-teal-mid);\n  border-radius: 0 var(--mat-radius-sm) var(--mat-radius-sm) 0;\n  padding: 10px 14px;\n  font-size: 0.8125rem;\n  color: var(--mat-green);\n  margin-bottom: 16px;\n}\n.mat-section-heading {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--mat-gray-400);\n  margin: 0 0 10px;\n}\n.mat-total-row td {\n  background: var(--mat-green-light);\n  color: var(--mat-green);\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n/* ── price modal ─────────────────────────────────────────────── */\n.mat-price-list { display: flex; flex-direction: column; gap: 2px; }\n.mat-price-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--mat-border);\n}\n.mat-price-row:last-child { border-bottom: none; }\n.mat-price-name { font-size: 0.85rem; font-weight: 500; margin: 0 0 2px; }\n.mat-price-meta { font-size: 0.75rem; color: var(--mat-gray-400); margin: 0; }\n.mat-price-input-wrap {\n  display: flex; align-items: center;\n  border: 1px solid var(--mat-border-md);\n  border-radius: var(--mat-radius-md);\n  overflow: hidden;\n  background: #fff;\n}\n.mat-price-prefix {\n  padding: 0 8px;\n  font-size: 0.8125rem;\n  color: var(--mat-gray-400);\n  background: var(--mat-gray-100);\n  border-right: 1px solid var(--mat-border);\n  height: 36px; display: flex; align-items: center;\n}\n.mat-price-input {\n  width: 100px; height: 36px;\n  border: none; outline: none;\n  padding: 0 10px;\n  font-size: 0.8125rem;\n  text-align: right;\n  font-family: var(--mat-font-mono);\n}\n\n/* ── form ─────────────────────────────────────────────────────── */\n.mat-form { display: flex; flex-direction: column; gap: 16px; }\n.mat-form__group label {\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--mat-gray-600);\n  margin-bottom: 6px;\n}\n.mat-form__group input,\n.mat-form__group select,\n.mat-form__group textarea {\n  width: 100%;\n  padding: 0 12px;\n  height: 38px;\n  border: 1px solid var(--mat-border-md);\n  border-radius: var(--mat-radius-md);\n  font-size: 0.875rem;\n  font-family: var(--mat-font);\n  background: #fff;\n  color: var(--mat-gray-900);\n  outline: none;\n  transition: border-color 0.13s, box-shadow 0.13s;\n  appearance: none;\n}\n.mat-form__group textarea {\n  height: auto; padding: 10px 12px; resize: vertical;\n}\n.mat-form__group input:focus,\n.mat-form__group select:focus,\n.mat-form__group textarea:focus {\n  border-color: var(--mat-teal);\n  box-shadow: 0 0 0 3px rgba(15,110,86,0.12);\n}\n.mat-required { color: var(--mat-red); margin-left: 2px; }\n\n/* ── delete modal ─────────────────────────────────────────────── */\n.mat-delete-body { text-align: center; padding: 8px 0 4px; }\n.mat-delete-icon {\n  width: 60px; height: 60px;\n  background: var(--mat-red-light);\n  color: var(--mat-red);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  margin: 0 auto 16px;\n}\n.mat-delete-body p { font-size: 0.875rem; color: var(--mat-gray-600); line-height: 1.6; margin: 0; }\n.mat-delete-body strong { color: var(--mat-gray-900); }\n\n/* ── image viewer ─────────────────────────────────────────────── */\n.mat-image-viewer {\n  position: fixed; inset: 0; z-index: 300;\n  background: rgba(0,0,0,0.85);\n  display: flex; align-items: center; justify-content: center;\n  cursor: zoom-out;\n  animation: mat-fade-in 0.15s ease;\n}\n.mat-image-viewer img {\n  max-width: 90vw; max-height: 90vh;\n  border-radius: var(--mat-radius-lg);\n  box-shadow: 0 24px 64px rgba(0,0,0,0.5);\n  cursor: default;\n}\n.mat-image-viewer__close {\n  position: absolute; top: 1.25rem; right: 1.25rem;\n  width: 36px; height: 36px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.15);\n  border: 1px solid rgba(255,255,255,0.25);\n  color: #fff; cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  transition: background 0.13s;\n}\n.mat-image-viewer__close:hover { background: rgba(255,255,255,0.25); }\n\n/* ── responsive ──────────────────────────mat-table-wrap─────────────────────── */\n@media (max-width: 768px) {\n  .mat-page { padding: 1rem 1rem 2rem; }\n  .mat-header { flex-direction: column; align-items: stretch; }\n  .mat-header__actions { flex-wrap: wrap; }\n  .mat-stats { grid-template-columns: 1fr; gap: 8px; }\n  .mat-detail-grid { grid-template-columns: 1fr; }\n  .mat-modal--md, .mat-modal--lg { width: 95vw; }\n  .mat-table { font-size: 0.75rem; }\n  .mat-table thead th,\n  .mat-table tbody td { padding: 8px 10px; }\n}\n\n\n\n/* ──────────────────────────────────────────────────────\n   ADD THESE CLASSES TO YOUR EXISTING material.css\n   (paste at the bottom of the file)\n   ────────────────────────────────────────────────────── */\n\n/* Inline material items list inside the main table */\n.mat-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 180px;\n  max-width: 300px;\n}\n\n.mat-item-chip {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 4px 8px;\n  background: #f0fdf8;\n  border-left: 2px solid #1D9E75;\n  border-radius: 3px;\n}\n\n.mat-item-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #0F6E56;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 260px;\n}\n\n.mat-item-meta {\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1.3;\n}\n\n/* Dark mode */\n@media (prefers-color-scheme: dark) {\n  .mat-item-chip {\n    background: rgba(29, 158, 117, 0.12);\n    border-left-color: #5DCAA5;\n  }\n  .mat-item-name {\n    color: #9FE1CB;\n  }\n  .mat-item-meta {\n    color: #888780;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   ADD MATERIAL FORM (am-*) — responsive redesign for AddMaterial.jsx\n   Namespaced tokens (--am-*) so they never override the --radius /\n   --danger / etc. tokens already defined above in this file.\n   ═══════════════════════════════════════════════════════════════ */\n\n:root {\n  --am-ink: #14213d;\n  --am-blueprint: #1d3557;\n  --am-amber: #e8a33d;\n  --am-amber-dark: #c9861f;\n  --am-canvas: #f5f7fa;\n  --am-card: #ffffff;\n  --am-line: #e2e8f0;\n  --am-muted: #64748b;\n  --am-danger: #dc2626;\n  --am-danger-bg: #fef2f2;\n  --am-radius: 10px;\n  --am-font: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n/* ---- Page shell ---- */\n.am-page {\n  min-height: 100vh;\n  background: var(--am-canvas);\n  padding: clamp(16px, 4vw, 48px);\n  font-family: var(--am-font);\n  color: var(--am-ink);\n  box-sizing: border-box;\n}\n\n.am-card {\n  max-width: 880px;\n  margin: 0 auto;\n  background: var(--am-card);\n  border: 1px solid var(--am-line);\n  border-radius: var(--am-radius);\n  padding: clamp(20px, 4vw, 40px);\n}\n\n/* ---- Header ---- */\n.am-header {\n  margin-bottom: 28px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--am-line);\n}\n\n.am-eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--am-blueprint);\n  margin-bottom: 8px;\n}\n\n.am-header h1 {\n  margin: 0 0 6px;\n  font-size: clamp(22px, 3vw, 28px);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.am-header p {\n  margin: 0;\n  color: var(--am-muted);\n  font-size: 14.5px;\n}\n\n/* ---- Alert ---- */\n.am-alert {\n  background: var(--am-danger-bg);\n  color: var(--am-danger);\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* ---- Sections ---- */\n.am-section {\n  margin-bottom: 32px;\n}\n\n.am-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.am-section-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--am-ink);\n  margin: 0 0 16px;\n}\n\n.am-section-head .am-section-title {\n  margin: 0;\n}\n\n.am-total-pill {\n  font-size: 13.5px;\n  color: var(--am-muted);\n  background: var(--am-canvas);\n  border: 1px solid var(--am-line);\n  border-radius: 999px;\n  padding: 6px 14px;\n  margin-bottom: 16px;\n}\n\n.am-total-pill strong {\n  color: var(--am-ink);\n  font-size: 15px;\n}\n\n/* ---- Fields ---- */\n.am-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.am-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.am-field label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--am-muted);\n}\n\n.am-field input,\n.am-field select,\n.am-field textarea {\n  font-family: var(--am-font);\n  font-size: 14.5px;\n  color: var(--am-ink);\n  background: var(--am-card);\n  border: 1px solid var(--am-line);\n  border-radius: 8px;\n  padding: 10px 12px;\n  /* width: 100%; */\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.am-field input:disabled,\n.am-field select:disabled {\n  background: var(--am-canvas);\n  color: var(--am-muted);\n  cursor: not-allowed;\n}\n\n.am-field input:focus-visible,\n.am-field select:focus-visible,\n.am-field textarea:focus-visible {\n  outline: none;\n  border-color: var(--am-blueprint);\n  box-shadow: 0 0 0 3px rgba(29, 53, 87, 0.15);\n}\n\n.am-field textarea {\n  resize: vertical;\n  min-height: 76px;\n}\n\n.am-field-static {\n  justify-content: flex-end;\n}\n\n.am-static-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--am-muted);\n}\n\n.am-static-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--am-ink);\n  padding: 10px 0;\n}\n\n/* File input styled as a button-like drop target */\n.am-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.am-file {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--am-muted);\n  border: 1px dashed var(--am-line);\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n\n.am-file:hover {\n  border-color: var(--am-blueprint);\n  color: var(--am-blueprint);\n}\n\n/* ---- Material items ---- */\n.am-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.am-item {\n  border: 1px solid var(--am-line);\n  border-radius: var(--am-radius);\n  padding: 16px;\n  background: var(--am-canvas);\n}\n\n.am-item-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 14px;\n  margin-bottom: 12px;\n}\n\n.am-remove {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--am-danger);\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 0;\n  cursor: pointer;\n}\n\n.am-remove:disabled {\n  color: var(--am-muted);\n  cursor: not-allowed;\n}\n\n.am-add-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 14px;\n  background: none;\n  border: 1px dashed var(--am-blueprint);\n  color: var(--am-blueprint);\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.am-add-row:hover {\n  background: rgba(29, 53, 87, 0.06);\n}\n\n/* ---- Footer ---- */\n.am-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid var(--am-line);\n}\n\n.am-submit {\n  background: var(--am-amber);\n  color: var(--am-ink);\n  border: none;\n  font-size: 15px;\n  font-weight: 700;\n  border-radius: 8px;\n  padding: 12px 28px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  width: 100%;\n}\n\n.am-submit:hover:not(:disabled) {\n  background: var(--am-amber-dark);\n}\n\n.am-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ---- Responsive tweaks ---- */\n@media (min-width: 480px) {\n  .am-submit {\n    width: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .am-card {\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n  }\n\n  .am-page {\n    padding: 0;\n  }\n\n  .am-item-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
